// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/base_system/main.css
// module id = 860
// module chunks = 41